import styles from "./BolusEventModal.module.scss"
import { usePolyglot } from "src/contexts"

const prefix = "components.event_modal.bolus."

export function InProgress() {
  const polyglot = usePolyglot()

  return (
    <div className={styles.inProgressContainer}>
      <span className={styles.inProgressText}>
        {polyglot.t(`${prefix}in_progress`)}
      </span>
    </div>
  )
}
